import { useGetSynchronizerLogs } from '@/apis/agency/systemSentiment/hook';
import DataTable from '@/components/Common/DataTable';
import Pagination, { usePagination } from '@/components/Common/Pagination';
import { formatDate, titleCase } from '@/utils/helperFunctions';
import { Box, Chip, FormControl, InputLabel, MenuItem, Select, Stack, Typography } from '@mui/material';
import { useState } from 'react';

export default function SyncLogs({ filters }: { filters: Record<string, any> }) {
  const { currentPage: page, perPage, setPage, setPerPage } = usePagination();
  const [status, setStatus] = useState<string>(' ');
  const { data: syncLogs, isLoading } = useGetSynchronizerLogs({
    page,
    per_page: perPage,
    filter: { integration_business_id_eq: filters.business_id, status_eq: status }
  });
  return (
    <Box border='1px solid #ECECEC' borderRadius={2} p={2} bgcolor='#fff'>
      <Stack direction='row' alignItems='center' justifyContent='space-between' mb={2}>
        <Typography fontSize={20} fontWeight={500}>
          Sync Logs
        </Typography>
        <FormControl
          size='small'
          sx={{
            minWidth: 180,
            '& fieldset': {
              borderColor: '#ececec'
            }
          }}
        >
          <InputLabel>Status</InputLabel>
          <Select value={status} label='Industry' onChange={(e) => setStatus(e.target.value)}>
            <MenuItem value=' '>All</MenuItem>
            <MenuItem value='completed'>Completed</MenuItem>
            <MenuItem value='failed'>Failed</MenuItem>
          </Select>
        </FormControl>
      </Stack>

      <DataTable
        data={syncLogs?.data ?? []}
        isLoading={isLoading}
        columns={[
          {
            header: 'Date',
            accessorKey: 'started_at',
            size: 50,
            cell: (info) => <Typography noWrap>{formatDate(info.row.original.started_at)}</Typography>
          },
          { header: 'Business', accessorKey: 'business_name', size: 50 },
          { header: 'Integration', accessorKey: 'integration_name', size: 50 },
          {
            header: 'Sync Type',
            size: 50,
            accessorKey: 'sync_type',
            cell: (info) => <Typography noWrap>{titleCase(info.row.original.sync_type)}</Typography>
          },
          { header: 'Status', size: 50, cell: (info: any) => getStatusChip(info.row.original.status) },
          {
            header: 'Duration',
            size: 50,
            accessorKey: 'total_duration'
          },
          { header: 'Total', size: 50, accessorKey: 'total_synced_count' },
          { header: 'New', size: 50, accessorKey: 'metadata.total_created_count' },
          { header: 'Updated', size: 50, accessorKey: 'metadata.total_updated_count' },
          { header: 'Failed', size: 50, accessorKey: 'total_failed_count' }
        ]}
      />

      <Pagination
        totalPages={syncLogs?.meta?.total_pages}
        totalCount={syncLogs?.meta?.total_count ?? 0}
        currentPage={page}
        perPage={perPage}
        onChange={setPage}
        onPerPageChange={setPerPage}
      />
    </Box>
  );
}

const getStatusChip = (status: string) => {
  const map: any = {
    completed: { bg: '#DCFCE7', color: '#16A34A' },
    failed: { bg: '#FEE2E2', color: '#DC2626' },
    started: { bg: '#FEF3C7', color: '#D97706' }
  };

  return (
    <Chip
      label={status}
      sx={{ borderRadius: '18px', fontSize: 12, bgcolor: map[status]?.bg, color: map[status]?.color }}
    />
  );
};
